if (!customElements.get('ao-home-quick-buy')) {
  customElements.define(
    'ao-home-quick-buy',
    class AOHomeQuickBuy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.variantInputs = [...this.querySelectorAll('[data-ao-home-variant]')];
        this.variantId = this.querySelector('[data-ao-home-variant-id]');
        this.price = this.querySelector('[data-ao-home-price]');
        this.submit = this.querySelector('[data-ao-home-submit]');
        this.submitLabel = this.submit?.querySelector('[data-ao-home-submit-label]');
        this.status = this.querySelector('[data-ao-home-status]');
        this.soldOutMessage = this.querySelector('.sold-out-message');
        this.addLabel = this.dataset.addLabel || '';
        this.soldOutLabel = this.dataset.soldOutLabel || '';
        this.productLabel = this.dataset.productLabel || '';

        this.handleChange = this.handleChange.bind(this);
        this.variantInputs.forEach((input) => input.addEventListener('change', this.handleChange));

        const selected = this.variantInputs.find((input) => input.checked) || this.variantInputs.find((input) => !input.disabled);
        if (selected) {
          selected.checked = true;
          this.update(selected);
        }
      }

      disconnectedCallback() {
        this.variantInputs?.forEach((input) => input.removeEventListener('change', this.handleChange));
        delete this.dataset.initialized;
      }

      handleChange(event) {
        if (!event.target.checked) return;
        this.update(event.target);
      }

      update(input) {
        const available = input.dataset.available === 'true' && !input.disabled;
        if (this.variantId) this.variantId.value = input.value;
        if (this.price && input.dataset.price) this.price.textContent = input.dataset.price;

        if (this.submit) {
          this.submit.disabled = !available;
          this.submit.setAttribute('aria-disabled', available ? 'false' : 'true');
          this.submit.setAttribute('aria-label', `${available ? this.addLabel : this.soldOutLabel} — ${this.productLabel}`);
        }

        this.submitLabel?.classList.toggle('hidden', !available);
        this.soldOutMessage?.classList.toggle('hidden', available);
        if (this.submitLabel) this.submitLabel.textContent = available ? this.addLabel : this.soldOutLabel;
        if (this.status) this.status.textContent = available ? '' : this.soldOutLabel;
      }
    },
  );
}
